import { CampsiteDetails } from '../campsite-details/types'
import { MapCampsite } from '../maps/domain/MapsCampsite'

export function campsiteToMapCampsite(campsite: CampsiteDetails): MapCampsite {
  return {
    ...campsite,
    id: campsite.id?.toString(),
    bookable: campsite.isBookable,
    categories: campsite.categories?.map((category) => ({
      ...category,
      id: category.id.toString(),
    })),
    rating: campsite.rating10,
    rating10: campsite.rating10,
    hierarchy: campsite.hierarchyTextShort,
    price: campsite.leadPrice,
    point: campsite.point,
    photo: {
      url: {
        large: campsite.primaryPhoto?.url?.mapLarge || '',
        medium: campsite.primaryPhoto?.url?.mapMedium || '',
        small: campsite.primaryPhoto?.url?.mapSmall || '',
      },
      caption: campsite.primaryPhoto?.caption || '',
    },
  }
}
